module.exports = __webpack_public_path__ + "static/Zasob5-d631b4c9a8b07127945d5f86d2c3fbe5.png";